// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";
// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText7 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (

    <div ref={ref} className={`container ${inView ? "animate" : ""}`} style={{justifyContent:"flex-start",padding:"0",margin:"10px 0px"}}>
      <div className="text a"> Who </div>
      <div className="text b"> is </div>
      <div className="text c"> Sudhanshu  </div>
      <div className="text d"> Batra? </div>
    </div>
  );
};
export default AnimatedText7;